module.exports = __webpack_public_path__ + "img/avatar.9fef31d0.webp";